"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _callbagShare = _interopRequireDefault(require("callbag-share"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default =
/* #__PURE__ */
(0, _callbagShare.default)(function (start, sink) {
  if (start !== 0) return;
  var id;

  function nextCb(ms) {
    sink(1, ms);
    next();
  }

  function next() {
    id = requestAnimationFrame(nextCb);
  }

  next();
  sink(0, function (t) {
    if (t === 2) cancelAnimationFrame(id);
  });
});

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/callbag-animation-frames/index.js
// module id = 630
// module chunks = 0